/**
 * Decompresses a gzip body. `/api/v2/files/{sha256}` serves pre-gzipped bytes
 * as `application/gzip` without `Content-Encoding`, so the browser hands them
 * over compressed; the client checks `gzipSha256` first, then unpacks here.
 */
export async function gunzip(bytes: ArrayBuffer): Promise<ArrayBuffer> {
  const body = new Response(new Uint8Array(bytes)).body
  if (body === null) throw new Error('gunzip: empty body')
  return new Response(body.pipeThrough(new DecompressionStream('gzip'))).arrayBuffer()
}
